import React from 'react';
import {IncotermsCode} from './incoterms/IncotermsCode.jsx';
import {IncotermsDescription} from './incoterms/IncotermsDescription.jsx';
import PropTypes from 'prop-types';
import {BrickContext} from 'olympe';

/**
 * @param {Incoterms.propTypes} props
 * @return {Element}
 */
export const Incoterms = (props) => {
    return (
        <div className={'pr-editor-header-details-incoterms'}>
            <IncotermsCode {...props} />
            <IncotermsDescription {...props}/>
        </div>
    );
};

Incoterms.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
    loading: PropTypes.bool,
};
